import queryString from 'query-string';
import SepaBatchConfirmationRequest from 'src/adminPanel/entities/offsetting/sepaBatch/SepaBatchConfirmationRequest';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi, { CallApiResult } from '.';

export const getSepaBatches = (
    pageable: PageableQueryParams,
    batchNumber: any,
    confirmedState: any
): Promise<CallApiResult> => {
    let query = queryString.stringify(
        {
            ...pageable,
            batchNumber: batchNumber || undefined,
            confirmedState: confirmedState !== null || confirmedState != undefined ? confirmedState : undefined,
        },
        { skipEmpty: true, skipNull: true }
    );
    if (query !== '') query = '?' + query;
    return callApi(`/api/batch/sepa/list${query}`);
};

export const getSepaBatchPreviewOrders = (id: string) => {
    return callApi(`/api/batch/sepa/${id}/previewOrders`);
};

export const confirmSepaBatch = (batchNumber: string, sepaBatchConfirmationRequest: SepaBatchConfirmationRequest) => {
    return callApi(`/api/batch/sepa/${batchNumber}/confirm`, {
        method: 'POST',
        data: sepaBatchConfirmationRequest,
    });
};
